export default "__VITE_ASSET__CLozOyuT__"